import semver from 'semver';
// Check if the MFE loads it's chunks into a unique global chunk namespace
export function getMFEHasUniqueChunkNamespace(bundledWith) {
    return !!isSupportedVersion(bundledWith === null || bundledWith === void 0 ? void 0 : bundledWith['@servicetitan/startup']);
}
function isSupportedVersion(version) {
    const minVersion = version && semver.minVersion(version);
    if (minVersion) {
        return semver.gte(minVersion, '27.2.0');
    }
}
//# sourceMappingURL=get-mfe-has-unique-chunk-namespace.js.map